var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { LatLng } from 'spherical-geometry-js';
import testPlaces from './testing/test-places.json';
/*App*/
export var FONT_FAMILY = 'Roboto, Public Sans, sans-serif';
export var TEST_TOKEN_TEXT = 'The rapid advancement of technology has dramatically transformed the way we live and work. From smartphones to artificial intelligence, these innovations have not only made our lives more convenient but have also reshaped industries across the globe. As businesses adapt to this new digital landscape, the need for continuous learning and upskilling has never been more critical. Those who embrace change and keep pace with technological advancements will be well-positioned for future success, while those who resist may find themselves struggling to remain competitive in an increasingly dynamic world.';
export var CHANGE_LOG_ENTRIES = [
    {
        version: '1.0.0',
        date: 'October 2024',
        description: 'Initial Release of Token Quotas; Basic token counting functionality; User-friendly interface with responsive design.',
    },
];
export var HELP_LINKS = [
    {
        url: 'https://platform.openai.com/docs/concepts',
        title: 'OpenAI Documentation',
    },
    {
        url: 'https://platform.openai.com/tokenizer',
        title: 'OpenAI Tokenizer',
    },
    {
        url: 'https://www.ibm.com/docs/en/watsonx/saas?topic=solutions-tokens',
        title: 'IBM WhatIs Tokenization',
    },
];
export var BOOLEAN_CHECKBOX_OPTIONS = [
    { value: 1, label: 'Yes' },
    { value: 0, label: 'No' },
];
export var HOWTO_STEPS = [
    {
        title: 'Step 1',
        text: 'Select the language model that you want to use for token counting. Different models may count tokens differently.',
    },
    {
        title: 'Step 2',
        text: 'Enter the text you want to analyze in the input field labeled "Text".',
    },
    {
        title: 'Step 3',
        text: 'Click the "Analyze" button to calculate the token count and other data about the text you entered.',
    },
];
export var PLACE_TYPES = [
    {
        value: 1,
        label: 'Food',
        description: '',
    },
    {
        value: 2,
        label: 'Shopping',
        description: '',
    },
    {
        value: 3,
        label: 'Entertainment',
        description: '',
    },
    {
        value: 4,
        label: 'Health',
        description: '',
    },
    {
        value: 5,
        label: 'Education',
        description: '',
    },
    {
        value: 6,
        label: 'Bars',
        description: '',
    },
    {
        value: 7,
        label: 'Night Life',
        description: '',
    },
];
export var MOCK_PLACES = testPlaces.map(function (place) { return (__assign(__assign({}, place), { coordinates: new LatLng(place.lat, place.lng) })); });
export var MOCK_SELECTED_PLACES = [
    __assign(__assign({}, MOCK_PLACES[0]), { voteCount: 0 }),
    __assign(__assign({}, MOCK_PLACES[2]), { voteCount: 0 }),
    __assign(__assign({}, MOCK_PLACES[5]), { voteCount: 0 }),
];
export var MOCK_PLACE_VOTES = [
    { voterId: 'mikeanderson', itemId: MOCK_SELECTED_PLACES[0].id },
    { voterId: 'jameschivery', itemId: MOCK_SELECTED_PLACES[0].id },
    { voterId: 'andrewdaly', itemId: MOCK_SELECTED_PLACES[0].id },
    { voterId: 'stevensmith', itemId: MOCK_SELECTED_PLACES[1].id },
    { voterId: 'brandonturner', itemId: MOCK_SELECTED_PLACES[1].id },
];
export var RADIUS_SELECT_OPTIONS = [
    { value: 1, label: '1 mile radius' },
    { value: 5, label: '5 mile radius' },
    { value: 10, label: '10 mile radius' },
    { value: 25, label: '25 mile radius' },
    { value: 50, label: '50 mile radius' },
];
export var MOCK_MAP_USERS = [];
export var DEFAULT_MAP_CENTER = { lat: 35.2271, lng: -80.8431 };
export var DEFAULT_MAP_ZOOM = 10; // 0(out) - 20(in)
export var MAX_SEARCH_RESULTS = 25;
export var MAP_SECTION_HEIGHT = 1000;
export var LOGIN_CODES = [
    'CG49G',
    'HJ3F4',
    'JG4H9',
    'KJ4G9',
    'JT2H7',
    'AS461',
    'JGSJI',
];
